import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        <div className="flex items-center gap-2.5">
          <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            {title}
          </h2>
        </div>
        {subtitle && (
          <p className="text-sm text-foreground-600 mt-2 pl-4">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}